import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useNews } from "../../TraningAcademy.hook";
import { fields, fieldsReady } from "../../constants";

export const TrainingAcademyLatestNews = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useNews();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);
  useEffect(() => {
    refetchEditData();
  }, []);

  const generateDynamicFields = (payload: any) => {
    if (!payload) return { latestNews: [] };

    const fields: any[] = [];

    fields.push(
      {
        name: "field_latest_news_text",
        label: "Latest News Text",
        type: "input",
        className: "col-span-6",
        placeholder: "Enter Latest News Text",
        rules: { required: "Latest News Text is required" },
      },
      {
        name: "field_latest_news_text_ms",
        label: "Latest News Text (Malay)",
        type: "input",
        className: "col-span-6",
        placeholder: "Enter Latest News Text in Malay",
      },
      {
        name: "field_latest_news_text_zhans",
        label: "Latest News Text (Chinese)",
        type: "input",
        className: "col-span-6",
        placeholder: "Enter Latest News Text in Chinese",
      }
    );

    // Dynamic news cards
    if (payload.view && Array.isArray(payload.view)) {
      const newsCards = payload.view.length > 0 ? payload.view : [{}];
      fields.push({
        fieldName: "News Cards",
        fieldValue: "view",
        type: "dynamicRow",
        className: "col-span-12",
        name: "view",
        dynamicFormType: "dynamicRow",
        placeholder: "",
        label: "News Cards",
        rowConfig: newsCards.map((_: any, cardIdx: number) => ({
          fields: [
            {
              fieldName: `Image ${cardIdx + 1}`,
              fieldValue: `view[${cardIdx}].image`,
              type: "file",
              className: "col-span-6",
              name: `view[${cardIdx}].image`,
              label: `Image ${cardIdx + 1}`,
              placeholder: "Upload News Image",
              accept: "image/*",
              validation: { required: "Image is Required" },
            },
            {
              fieldName: `Header ${cardIdx + 1}`,
              fieldValue: `view[${cardIdx}].header`,
              type: "richText",
              className: "col-span-6",
              name: `view[${cardIdx}].header`,
              label: `Header ${cardIdx + 1}`,
              placeholder: "Enter News Header",
              validation: { required: "Header is Required" },
            },
            {
              fieldName: `Date ${cardIdx + 1}`,
              fieldValue: `view[${cardIdx}].date`,
              type: "date",
              className: "col-span-6",
              name: `view[${cardIdx}].date`,
              label: `Date ${cardIdx + 1}`,
              placeholder: "Select Date",
              validation: { required: "Date is Required" },
            },
            {
              fieldName: `Description ${cardIdx + 1}`,
              fieldValue: `view[${cardIdx}].description`,
              type: "richText",
              className: "col-span-6",
              name: `view[${cardIdx}].description`,
              label: `Description ${cardIdx + 1}`,
              placeholder: "Enter News Description",
              validation: { required: "Description is Required" },
            },
          ],
        })),
      });
    }

    return { latestNews: fields };
  };

  useEffect(() => {
    const fetchData = async () => {
      if (editData?.[0]?.nid) {
        const id = editData[0].nid;
        await fieldsReady(id);
        setFieldData(fields);
      } else if (dataById?.payload) {
        const dynamicFields = generateDynamicFields(dataById.payload);
        setFieldData(dynamicFields);
      } else {
        await fieldsReady();
        setFieldData(fields);
      }
    };

    fetchData();
  }, [editData, dataById]);

  const NewsFormConfig: FormConfig = {
    initialValues: {
      // published: dataById ? decodeHTML(dataById.payload?.published) : editData ? decodeHTML(editData?.published) : false,
      field_latest_news_text: dataById
        ? decodeHTML(dataById.payload.field_latest_news_text)
        : editData
          ? decodeHTML(editData?.[0]?.field_latest_news_text)
          : "",
      field_latest_news_text_ms: dataById
        ? decodeHTML(dataById.payload.field_latest_news_text_ms)
        : editData
          ? decodeHTML(editData?.[0]?.field_latest_news_text_ms)
          : "",
      field_latest_news_text_zhans: dataById
        ? decodeHTML(dataById.payload.field_latest_news_text_zhans)
        : editData
          ? decodeHTML(editData?.[0]?.field_latest_news_text_zhans)
          : "",
      //   view: dataById?.payload?.view
      //     ? dataById.payload.view.map((card: { id: string; image: string; header: string; date: string; description: string }) => ({
      //         id: card.id,
      //         image: decodeHTML([
      //           {
      //             uid: "-1",
      //             name: "news_image.png",
      //             status: "done",
      //             url: card.image,
      //           },
      //         ]),
      //         header: decodeHTML(card.header),
      //         date: decodeHTML(card.date),
      //         description: decodeHTML(card.description),
      //       }))
      //     : editData?.[0]?.view
      //     ? editData[0].view.map((card: { id: string; image: string; header: string; date: string; description: string }) => ({
      //         id: card.id,
      //         image: decodeHTML([
      //           {
      //             uid: "-1",
      //             name: "news_image.png",
      //             status: "done",
      //             url: card.image,
      //           },
      //         ]),
      //         header: decodeHTML(card.header),
      //         date: decodeHTML(card.date),
      //         description: decodeHTML(card.description),
      //       }))
      //     : [],
    },
    fields: fieldData?.latestNews || [],
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const newsCards = data.view || [];
    for (const card of newsCards) {
      if (card.image && card.image[0]?.originFileObj) {
        const formData = new FormData();
        formData.append("upload-file", card.image[0].originFileObj);
        formData.append("application", "CORPORATE");
        const res: any = await post("management/upload-file", formData);
        if (res?.response?.data) {
          card.image = res.response.data;
        }
      } else if (card.image && card.image[0]?.url) {
        card.image = card.image[0].url;
      }
    }
    // data.view = newsCards;
    data.view = newsCards.map((item: any) => {
      if (item.id && item.id.toString().startsWith("new")) {
        const { id, ...rest } = item;
        return rest;
      }
      return item;
    });
    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "news_latestNews",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_News",
      payload: {
        ...(action === "UPDATE" && { nid: editData?.[0]?.nid || dataById?.payload?.nid }),
        ...data,
        published: true,
      },
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status === "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          navigate(`/dedicated/status-information?activeTab=${status === "PENDING" ? "pending" : "draft"}`);
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status === "DRAFT" ? "Data Saved Successfully" : "Data Sent for Review",
            type: "success",
          });
          navigate(`/dedicated/status-information?activeTab=${status === "PENDING" ? "pending" : "draft"}`);
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    // <ContentWrapper
    //   title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} News`}
    //   showBack
    // >
    <DynamicForm
      isLoading={isLoadingData || drilldownLoading}
      config={NewsFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${corporateHost}/api/airports-ac-latest-news/${editData?.[0]?.nid || dataById?.payload?.nid}`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Malaysia Airports Academy"
    />
    // </ContentWrapper>
  );
};
